export default "__VITE_ASSET__ea4b7b4c__"